import { responsiveFontSizes, createTheme } from '@mui/material/styles';
import createCache from '@emotion/cache';
import { heIL } from '@mui/material/locale';
import { heIL as dateHeLI } from '@mui/x-date-pickers/locales';
import { commonCache, commonComponentsStyles, commonShape, commonTypography } from '@sm-dashboard/theme';

export const theme = responsiveFontSizes(
  createTheme(
    {
      palette: {
        common: {
          white: '#ffffff'
        },
        warning: {
          main: 'rgb(255, 230, 207)',
          "400": '#eda482',
          "800": '#606548'
        },
        primary: {
          main: '#513996'
        },
        success: {
          main: '#94C11F'
        },
        secondary: {
          main: '#1dbcd7'
        },
        error: {
          main: '#FE5857'
        },
        info: {
          main: '#8276BE'
        },
        grey: { A100: '#E3E3E3', A200: '#f1f1f5' },
        background: {
          default: '#ffff',
          paper: '#f2f2f2'
        }
      },
      typography: { ...commonTypography },
      shape: { ...commonShape, borderRadius: 8 },
      components: { ...commonComponentsStyles, MuiRating: { defaultProps: { dir: 'ltr' } } }
    },
    dateHeLI,
    heIL
  ),
  {
    variants: []
  }
);

export const cacheRtl = createCache({
  ...commonCache
});

declare module '@mui/material/styles' {
  interface Palette {
    formGray?: {
      dark: string;
    };
  }
  interface PaletteOptions {
    formGray?: {
      dark: string;
    };
  }
}
